import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetTypeCatalog } from "./GetTypeCatalog";
import { GetAssets } from "screens/Inventory/logic/AssetService";
import { SaveJobAsset } from "./SaveJobAsset";
import { GetJobAssets } from "./GetJobAsset";
import { DeleteJobAsset } from "./DeleteJobAsset";
import { DeleteJobObservation } from "./DeleteJobObservation";
import { SaveJobObservation } from "./SaveJobObservation";
import { GetJobObservations } from "./GetJobObservation";
import { GetJobMaterials } from "./GetJobMaterial";
import { SaveJobMaterial } from "./SaveJobMaterial";
import { DeleteJobMaterial } from "./DeleteJobMaterial";
import { GetMaterials } from "./GetMaterials";
import { formatUSCurrency } from "components/CurrencyFormat";
import { SaveJobLabor } from "./SaveJobLabor";
import { DeleteJobLabor } from "./DeleteJobLabor";
import { GetJobLabors } from "./GetJobLabor";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";
import { GetSkills } from "screens/Employees/logic/GetSkills";
import { GetJobMiscCosts } from "./GetJobMiscCost";
import { SaveJobMiscCost } from "./SaveJobMiscCost";
import { DeleteJobMiscCost } from "./DeleteJobMiscCost";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { getTargetJobID } from "./lineItemUtils";
import { styled, useTheme } from "@mui/material/styles";
import { getUnits } from "screens/Inventory/logic/UnitofMeasurementlogic";
import { GetSubcontractors } from "./GetSubcontractors";
import { DeleteJobSubcontractor, GetJobSubcontractor, SaveJobSubcontractor } from "./JobSubcontractor";

export const useLineItemLogic = ({entity, workReq, setLoading, toast, job}) => {
  //#region Hooks

  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const theme = useTheme();

  //#endregion

  //#region Constants
  if (!entity) throw new Error("entity is required for useLineItemLogic");


  const jobID = getTargetJobID(workReq, job, entity);
  const isActuals = entity === "jobDetailActual";

  useEffect(() => {
    setAsset(a => ({ ...a, jobID }));
    setObservation(o => ({ ...o, jobID }));
    setMaterial(m => ({ ...m, jobID }));
    setLabor(l => ({ ...l, jobID }));
    setSubcontractor(s => ({ ...s, jobID }));
    setMiscCost(m => ({ ...m, jobID }));
  }, [jobID]);

  const isNumberOnly = (input) => {
    const numberRegex = /^\d*\.?\d*$/
    return numberRegex.test(input);
  }

  //#endregion End of Constants

  //#region States
const [units, setUnits] = useState([]);
  const [openAddLineItem, setOpenAddLineItem] = useState(false);
  const [LineItemContent, setLineItemContent] = useState({
    Title: "Add Assest",
    Type: "Asset",
  });

  //Job Asset
  const [assetTypesList, setAssetTypesList] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  const initialAssetState = {
    "jobAssetID": 0,
    "jobID": 0,
    "assetID": 0,
    "assetTypeID": 0,
    "budgetedQuantity": 1,
    "budgetedCostPerUnit": 0,
    "budgetedDuration": null,
    "budgetedPricePerUnit": 0,
    "budgetedMarkup": 0,
    "actualQuantity": 0,
    "actualCostPerUnit": 0,
    "actualDuration": 0,
    "actualPricePerUnit": 0,
    "actualMarkup": 0,
    "billToCustomer": true,
    "billingUnit": "Hour",
    "rentalStatus": "Owned",
    "providedBy": null,
    "sortOrder": null,
    "notes": ""
  }
  const [asset, setAsset] = useState(
    {
      ...initialAssetState,
      jobID: jobID,
    }
  );
  const [jobAssetList, setJobAssetList] = useState([]);
  const [rowsAsset, setRowsAsset] = useState([]);
  const [assetErrors, setAssetErrors] = useState({});
  
  //Job Observation

  const initialObservationState = {
    "observationID": 0,
    "jobID": 0,
    "observationName": "",
    "observationDescription": ""
  }
  const [observation, setObservation] = useState(
    {
      ...initialObservationState,
      jobID: jobID,
    }
  );
  const [jobObservationList, setJobObservationList] = useState([]);
  const [observationErrors, setObservationErrors] = useState({});

  //Job Material

  const [materialTypesList, setMaterialTypesList] = useState([]);
  const [materialsList, setMaterialsList] = useState([]);
  const initialMaterialState = {
    "jobMaterialID": 0,
    "jobID": 0,
    "materialID": 0,
    "materialTypeID": 0,
    "sku": "",
    "unitID": 0,
    "budgetedQuantity": 1,
    "budgetedCostPerUnit": 0,
    "budgetedPricePerUnit": 0,
    "budgetedMarkup": 0,
    "actualQuantity": 0,
    "actualCostPerUnit": 0,
    "actualPricePerUnit": 0,
    "actualMarkup": 0,
    "providedBy": 0,
    "sortOrder": 0,
    "notes": ""
  }
  const [material, setMaterial] = useState(
    {
      ...initialMaterialState,
      jobID: jobID,
    }
  );
  const [jobMaterialList, setJobMaterialList] = useState([]);
  const [rowsMaterial, setRowsMaterial] = useState([]);
  const [materialErrors, setMaterialErrors] = useState({});

  //Job Labor

  const [skillTypesList, setSkillTypesList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const initialLaborState = {
    "jobLaborID": 0,
    "jobID": 0,
    "skillID": null,
    "employeeID": null,
    "teamID": 0,
    "budgetedCostPerHour": 0,
    "budgetedPricePerUnit": 0,
    "budgetedHours": 0,
    "budgetedMarkup": 0,
    "actualCostPerHour": 0,
    "actualPricePerUnit": 0,
    "actualHours": 0,
    "actualMarkup": 0,
    "providedBy": 0,
    "sortOrder": 0,
    "notes": "string",
    "wageType": "",
  }
  const [labor, setLabor] = useState(
    {
      ...initialLaborState,
      jobID: jobID,
    }
  );
  const [jobLaborList, setJobLaborList] = useState([]);
  const [rowsLabor, setRowsLabor] = useState([]);
  const [laborErrors, setLaborErrors] = useState({});

    //Job Subcontractor
  const [subcontractorList, setSubcontractorList] = useState([]);
  const initialSubcontractorState = {
    "jobSubcontractorID": 0,
    "jobID": 0,
    "skillID": null,
    "employeeID": null,
    "teamID": 0,
    "unitID": 0,
    "budgetedUnitQuantity": 0,
    "budgetedCostPerUnit": 0,
    "budgetedPricePerUnit": 0,
    "budgetedMarkup": 0,
    "actualUnitQuantity": 0,
    "actualCostPerUnit": 0,
    "actualPricePerUnit": 0,
    "actualMarkup": 0,
    "providedBy": 0,
    "sortOrder": 0,
    "notes": "",
  }
  const [subcontractor, setSubcontractor] = useState(
    {
      ...initialSubcontractorState,
      jobID: jobID,
    }
  );
  const [jobSubcontractorList, setJobSubcontractorList] = useState([]);
  const [rowsSubcontractor, setRowsSubcontractor] = useState([]);
  const [subcontractorErrors, setSubcontractorErrors] = useState({});

  //Job MiscCost

  const initialMiscCostState = {
    "miscCostID": 0,
    "jobID": 0,
    "costName": "",
    "costDescription": "",
    "billToCustomer": true,
    "sortOrder": 0,
    "budgetedCostAmount": 0,
    "budgetedCustomerPrice": 0,
    "actualCostAmount": 0,
    "actualCustomerPrice": 0
  }
  const [miscCost, setMiscCost] = useState(
    {
      ...initialMiscCostState,
      jobID: jobID,
    }
  );
  const [jobMiscCostList, setJobMiscCostList] = useState([]);
  const [rowsMiscCost, setRowsMiscCost] = useState([]);
  const [miscCostErrors, setMiscCostErrors] = useState({});  

  //#endregion end of states

  //#region Handlers and methods

  const handleAddLineItemOpenAsset = () => {
    ResetAsset();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Asset",
      Type: "Asset",
    });
  }
  const handleAddLineItemOpenObservation = () => {
    ResetObservation();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Observation",
      Type: "Observation",
    });
  }
  const handleAddLineItemOpenLabor = () => {
    ResetLabor();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Laborer",
      Type: "Labor",
    });
  }
  const handleAddLineItemOpenSubcontractor = () => {
    ResetSubcontractor();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Subcontractor",
      Type: "Subcontractor",
    });
  }
  const handleAddLineItemOpenMaterial = () => {
    ResetMaterial();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Material",
      Type: "Material",
    });
  }
  const handleAddLineItemOpenOtherCosts = () => {
    ResetMiscCost();
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Add Other Costs",
      Type: "MiscCost",
    });
  }
  const handleLineItemClose = () => {
    setOpenAddLineItem(false);
  };

  //#region Asset Handlers
  const handleAssetChange = (field, value) => {
    if (field === '__DIRECT_UPDATE__') {
      // Special case: directly update asset with provided data (for newly created assets)
      setAsset((prevState) => ({
        ...prevState,
        ...value
      }));
    } else if (field === 'assetTypeID') {
      setAsset((prevState) => ({
        ...prevState,
        [field]: value,
        assetID: 0,
        budgetedQuantity: isActuals ? 0 : 1,
        budgetedCostPerUnit: 0,
        budgetedDuration: '',
        budgetedPricePerUnit: 0,
        budgetedMarkup: 0,
        actualQuantity: isActuals ? 1 : 0,
        actualCostPerUnit: 0,
        actualDuration: '',
        actualPricePerUnit: 0,
        actualMarkup: 0,
        billToCustomer: true,
        providedBy: 0
      }));
    } else if (field === 'assetID') {
      const selectedAsset = assetsList.find(item => item.assetID === value);
      if (selectedAsset) {
        setAsset((prevState) => ({
          ...prevState,
          [field]: value,
          budgetedCostPerUnit: selectedAsset.operationalCostsAmount,
          actualCostPerUnit: isActuals ? selectedAsset.operationalCostsAmount : prevState.actualCostPerUnit,
          DurationUnit: selectedAsset.operationalCostsUnit
        }));
      }
    } else if (
      field === 'budgetedQuantity' ||
      field === 'budgetedDuration' ||
      field === 'actualQuantity' ||
      field === 'actualDuration'
    ) {
      if (isNumberOnly(value)) {
        setAsset((prevState) => ({ ...prevState, [field]: value }));
      }
    } 
    else if (
      field === 'budgetedPricePerUnit'
    ) {
      if (isNumberOnly(value)) {
        setAsset((prevState) => {
          const cost = prevState.budgetedCostPerUnit || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, budgetedMarkup: Math.round(markup) };
        });
      }
    } 
    else if (
      field === 'budgetedCostPerUnit'
    ) {
      if (isNumberOnly(value)) {
        setAsset((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.budgetedMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else if (
      field === 'budgetedMarkup'
    ) {
      const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
      if (isValidInput) {
        setAsset((prevState) => {
          const cost = prevState.budgetedCostPerUnit || 0;
          const markupValue = parseFloat(value) || 0;
          const price = cost * (1 + markupValue / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else if (
      field === 'actualPricePerUnit' 
    ) {
      if (isNumberOnly(value)) {
        setAsset((prevState) => {
          const cost = prevState.actualCostPerUnit || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, actualMarkup: Math.round(markup) };
        });
      }
    } 
    else if (
      field === 'actualCostPerUnit'
    ) {
      if (isNumberOnly(value)) {
        setAsset((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.actualMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            actualPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else if (
      field === 'actualMarkup'
    ) {
      const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
      if (isValidInput) {
        setAsset((prevState) => {
          const cost = prevState.actualCostPerUnit || 0;
          const markupValue = parseFloat(value) || 0;
          const price = cost * (1 + markupValue / 100);
          return { 
            ...prevState, 
            [field]: value, 
            actualPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else {
      setAsset((prevState) => ({ ...prevState, [field]: value }));
    }
  };
  
  const validateAssetFields = () => {
    let tempErrors = {};
    if (!asset.assetTypeID || asset.assetTypeID < 1) tempErrors.assetTypeID = 'Asset Type is required';
    if (!asset.assetID || asset.assetID < 1) tempErrors.assetID = 'Asset is required';
  
    if (isActuals) {
      if (!asset.actualQuantity || asset.actualQuantity <= 0) tempErrors.actualQuantity = 'Actual Quantity must be greater than 0';
      if (!asset.actualDuration || asset.actualDuration <= 0) tempErrors.actualDuration = 'Actual Duration is required';
      if ((!asset.actualPricePerUnit || asset.actualPricePerUnit <= 0) && asset.billToCustomer) tempErrors.actualPricePerUnit = 'Actual Price Per Unit must be greater than 0';    
      if (!asset.actualCostPerUnit || asset.actualCostPerUnit <= 0) tempErrors.actualCostPerUnit = 'Actual Cost Per Unit must be greater than 0';
      if (!asset.actualMarkup || asset.actualMarkup <= 0) tempErrors.actualMarkup = 'Markup must be greater than 0';
    } else {
      if (!asset.budgetedQuantity || asset.budgetedQuantity <= 0) tempErrors.budgetedQuantity = 'Quantity must be greater than 0';
      if (!asset.budgetedDuration || asset.budgetedDuration <= 0) tempErrors.budgetedDuration = 'Duration is required';
      if ((!asset.budgetedPricePerUnit || asset.budgetedPricePerUnit <= 0) && asset.billToCustomer) tempErrors.budgetedPricePerUnit = 'Price Per Unit must be greater than 0';    
      if (!asset.budgetedCostPerUnit || asset.budgetedCostPerUnit <= 0) tempErrors.budgetedCostPerUnit = 'Cost Per Unit must be greater than 0';
      if (!asset.budgetedMarkup || asset.budgetedMarkup <= 0) tempErrors.budgetedMarkup = 'Markup must be greater than 0';
    }
  
    setAssetErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }
  
  const fetchJobAssets = async (workReqID) => {
    try {
      const data = await GetJobAssets(workReqID, 0, jobID, navigate);
      setJobAssetList(
        data
          .filter(asset => asset.jobID === jobID)
          .map(({jobAssetID, ...rest}) => ({
        id: jobAssetID,
        jobAssetID,
        ...rest,
          }))
      );
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  }
  const ResetAsset = () => {
    setAsset({
      ...initialAssetState,
      jobID: jobID,
    });
  }
  const handleSaveJobAsset = async () => {    
    if (validateAssetFields()) {      
      try {
        const duplicateAssets = jobAssetList.filter( x => x.assetID == asset?.assetID)        
        if(duplicateAssets.length > 0 && LineItemContent?.Title === "Add Asset"){
          toast.warning(`Assest with same name already exists.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          return;
        }else{
          // console.log(asset)
          SaveAsset();
        }                        
      } catch (error) {
        toast.error(error);
        console.error('Error saving Asset:', error);
      }
    }
  }

  // useEffect(() => {
  //   if (saveAssetFlag) {
  //     SaveAsset();
  //   } 
  // }, [saveAssetFlag]);

  const SaveAsset = async () => {    
      setLoading(true);
      try {
        const getAsset = assetsList.find((item) => item.assetID === asset.assetID);
      let budgetedFields = {
        budgetedQuantity: 0,
        budgetedCostPerUnit: 0,
        budgetedDuration: 0,
        budgetedPricePerUnit: 0,
        budgetedMarkup: 0
      };
      if (isActuals) {
        // Fetch current budgeted values for this asset
        const jobAssets = await GetJobAssets(workReq?.workReqID || 0, asset.jobAssetID, asset.jobID, navigate);
        const current = Array.isArray(jobAssets) ? jobAssets.find(a => a.jobAssetID === asset.jobAssetID) : null;
        if (current) {
          budgetedFields = {
            budgetedQuantity: current.budgetedQuantity ?? 0,
            budgetedCostPerUnit: current.budgetedCostPerUnit ?? 0,
            budgetedDuration: current.budgetedDuration ?? 0,
            budgetedPricePerUnit: current.budgetedPricePerUnit ?? 0,
            budgetedMarkup: current.budgetedMarkup ?? 0
          };
        }
      } else {
        budgetedFields = {
          budgetedQuantity: asset.budgetedQuantity,
          budgetedCostPerUnit: asset.budgetedCostPerUnit,
          budgetedDuration: asset.budgetedDuration,
          budgetedPricePerUnit: asset.budgetedPricePerUnit,
          budgetedMarkup: asset.budgetedMarkup
        };
      }
      const payloadJobAsset = {
        jobAssetID: asset.jobAssetID,
        jobID: asset.jobID,
        assetID: asset.assetID,
        assetTypeID: asset.assetTypeID,
        ...budgetedFields,
        ...(isActuals ? {
          actualQuantity: Number(asset.actualQuantity) || 0,
          actualCostPerUnit: Number(asset.actualCostPerUnit) || 0,
          actualDuration: Number(asset.actualDuration) || 0,
          actualPricePerUnit: Number(asset.actualPricePerUnit) || 0,
          actualMarkup: Number(asset.actualMarkup) || 0,
        } : {}),
        billToCustomer: Boolean(asset.billToCustomer),
        billingUnit: getAsset?.operationalCostsUnit || "Hour",
        rentalStatus: asset.rentalStatus || "Owned",
        providedBy: Number(asset.providedBy) || 0,
        sortOrder: Number(asset.sortOrder) || 0,
        notes: asset.notes || ""
      };
      console.log(payloadJobAsset)
      const result = await SaveJobAsset(payloadJobAsset, navigate, isActuals);
        if (result && !result.isError) {
          setOpenAddLineItem(false);
          toast.success(`Asset saved successfully.`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });
        }
        else{
          toast.error(result.message)
        }
      } catch (error) {
        console.error('Error saving asset:', error);
      } finally {
        setLoading(false);
        fetchJobAssets(workReq?.workReqID);
        ResetAsset();
      }
  };

  const handleJobAssetEdit = (jobAsset) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit Asset",
      Type: "Asset",
    });
    // Ensure all numeric values are properly converted and defaulted
    const processedAsset = {
      ...initialAssetState,
      ...jobAsset,
      assetTypeID: Number(jobAsset.assetTypeID) || 0,
      assetID: Number(jobAsset.assetID) || 0,
      providedBy: Number(jobAsset.providedBy) || 0,
      // Budgeted values
      budgetedQuantity: Number(jobAsset.budgetedQuantity) || 0,
      budgetedCostPerUnit: Number(jobAsset.budgetedCostPerUnit) || 0,
      budgetedDuration: Number(jobAsset.budgetedDuration) || 0,
      budgetedPricePerUnit: Number(jobAsset.budgetedPricePerUnit) || 0,
      budgetedMarkup: Number(jobAsset.budgetedMarkup) || 0,
      // Actual values
      actualQuantity: Number(jobAsset.actualQuantity) || 0,
      actualCostPerUnit: Number(jobAsset.actualCostPerUnit) || 0,
      actualDuration: Number(jobAsset.actualDuration) || 0,
      actualPricePerUnit: Number(jobAsset.actualPricePerUnit) || 0,
      actualMarkup: Number(jobAsset.actualMarkup) || 0,
      // Boolean values
      billToCustomer: Boolean(jobAsset.billToCustomer),
      // Preserve other fields
      DurationUnit: jobAsset.DurationUnit || "Hour",
      rentalStatus: jobAsset.rentalStatus || "Owned",
      notes: jobAsset.notes || "",
    };
    setAsset(processedAsset);
  };
  
  const handleJobAssetDelete = async (jobAssetID) => {
    if (jobAssetID) {
      try {
        const result = await DeleteJobAsset(jobAssetID, jobID, navigate);
        if (result && !result.isError) {
          fetchJobAssets(workReq?.workReqID);
          toast.success(`Asset removed successfully.`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting asset:', error);
      }
    }
  }
  const fetchTypeCatalog = async () => {
    try {
      const dataAsset = await GetTypeCatalog(0, 'Asset', navigate);
      setAssetTypesList(dataAsset);
      //(dataAsset)
      const dataMaterial = await GetTypeCatalog(0, 'Material', navigate);
      setMaterialTypesList(dataMaterial);
    } catch (error) {
      console.error('Error fetching type catalog:', error);
    }
  }
  const fetchAssets = async () => {
    try {
      const data = await GetAssets(0, navigate);
      setAssetsList(data.result);
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  }
  useEffect(() => {
    if (Object.keys(assetErrors).length > 0) {
      const timer = setTimeout(() => {
        setAssetErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [assetErrors]);

  //#endregion End of Asset Handlers 

  //#region Observation Handlers

  const handleObservationChange = (field, value) => {
    setObservation((prevState) => ({ ...prevState, [field]: value }));
  }

  const validateObservationFields = () => {
    let tempErrors = {};
    if (!observation.observationName) tempErrors.observationName = 'Observation Name is required';
    if (!observation.observationDescription) tempErrors.observationDescription = 'Description is required';
    setObservationErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const fetchJobObservations = async (workReqID) => {
    try {
      const data = await GetJobObservations(workReqID, 0, jobID, navigate);
      setJobObservationList(data);
    } catch (error) {
      console.error('Error fetching Observations:', error);
    }
  }

  const ResetObservation = () => {
    setObservation({
      ...initialObservationState,
      jobID: jobID,
    });
  }

  const handleJobObservationEdit = (jobObservation) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit Observation",
      Type: "Observation",
    });
    const ObservationToEdit = jobObservationList.find((item) => item.jobObservationID === jobObservation.jobObservationID);
    if (ObservationToEdit) {
      setObservation(ObservationToEdit);
    }
  }

 const handleSaveJobObservation = async () => {
  if (validateObservationFields()) {
    setLoading(true);
    try {
      const result = await SaveJobObservation(observation, navigate);
      if (result && !result.isError) {
        setOpenAddLineItem(false);
        const isEdit = LineItemContent?.Title?.startsWith("Edit");
        const message = isEdit 
          ? "Observation updated successfully." 
          : "Observation added successfully.";
        
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '15px',
          },
        });
      }
    } catch (error) {
      console.error('Error saving Observation:', error);
    } finally {
      setLoading(false);
      fetchJobObservations(workReq?.workReqID);
      ResetObservation();
    }
  }
}

  const handleJobObservationDelete = async (jobObservationID) => {
    if (jobObservationID) {
      try {
        const result = await DeleteJobObservation(jobObservationID, jobID, navigate);
        if (result && !result.isError) {
          fetchJobObservations(workReq?.workReqID);
          toast.success(`Observation removed successfully.`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting Observation:', error);
      }
    }
  }

  useEffect(() => {
    if (Object.keys(observationErrors).length > 0) {
      const timer = setTimeout(() => {
        setObservationErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [observationErrors]);

  //#endregion End Observation Handlers

  //#region Material Handlers

  const handleMaterialChange = (field, value) => {
    if (field === '__DIRECT_UPDATE__') {
      // Special case: directly update material with provided data (for newly created materials)
      setMaterial((prevState) => ({
        ...prevState,
        ...value
      }));
    } else if (field === 'materialTypeID') {
      setMaterial((prevState) => ({
        ...prevState,
        [field]: value,
        materialID: 0,
        materialTypeID: value,
        unitID: 0,
        budgetedQuantity: isActuals ? 0 : 1, 
        budgetedCostPerUnit: 0,
        budgetedPricePerUnit: 0,
        budgetedMarkup: 0,
        actualQuantity: isActuals ? 1 : 0,
        actualCostPerUnit: 0,
        actualPricePerUnit: 0,
        actualMarkup: 0,
        providedBy: 0,
      }));
    } else if (field === 'materialID') {
      const selectedMaterial = materialsList.find(item => item.materialID === value);
      if (selectedMaterial) {
        setMaterial((prevState) => ({
          ...prevState,
          [field]: value,
          unitID: selectedMaterial.unitID,
          budgetedCostPerUnit: selectedMaterial.costPerUnit,
          actualCostPerUnit: isActuals ? selectedMaterial.costPerUnit : prevState.actualCostPerUnit,
          availableQuantity: selectedMaterial.quantityInStock,
          budgetedPricePerUnit: selectedMaterial.perUnitPrice,
          actualPricePerUnit: isActuals ? selectedMaterial.perUnitPrice : prevState.actualPricePerUnit
        }));
      }
    } 
    else if (
      field === 'budgetedQuantity' ||
      field === 'actualQuantity'
    ) {
      if (isNumberOnly(value)) {
        setMaterial((prevState) => ({ ...prevState, [field]: value }));
      }
    } 
    else if (
      field === 'budgetedCostPerUnit'
    ) {
      if (isNumberOnly(value)) {
        setMaterial((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.budgetedMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else if (
      field === 'budgetedPricePerUnit'
    ) {
      if (isNumberOnly(value)) {
        setMaterial((prevState) => {
          const cost = prevState.budgetedCostPerUnit || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, budgetedMarkup: Math.round(markup) };
        });
      }
    } 
    else if (
      field === 'budgetedMarkup'
    ) {
        const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
        
        if (isValidInput) {
          setMaterial((prevState) => {
            const cost = prevState.budgetedCostPerUnit || 0;
            const markupValue = parseFloat(value) || 0;
            const price = cost * (1 + markupValue / 100);
            return { 
              ...prevState, 
              [field]: value, 
              budgetedPricePerUnit: price.toFixed(2)
            };
          });
        }
    }
    else if (
      field === 'actualPricePerUnit'
    ) {
      if (isNumberOnly(value)) {
        setMaterial((prevState) => {
          const cost = prevState.actualCostPerUnit || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, actualMarkup: Math.round(markup) };
        });
      }
    } 
    else if (
      field === 'actualCostPerUnit'
    ) {
      if (isNumberOnly(value)) {
        setMaterial((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.actualMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            actualPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else if (
      field === 'actualMarkup'
    ) {
      const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
      if (isValidInput) {
        setMaterial((prevState) => {
          const cost = prevState.actualCostPerUnit || 0;
          const markupValue = parseFloat(value) || 0;
          const price = cost * (1 + markupValue / 100);
          return { 
            ...prevState, 
            [field]: value, 
            actualPricePerUnit: price.toFixed(2)
          };
        });
      }
    } 
    else {
      setMaterial((prevState) => ({ ...prevState, [field]: value }));
    }
  };
  
  const validateMaterialFields = () => {
    let tempErrors = {};
    if (!material.materialTypeID || material.materialTypeID < 0) tempErrors.materialTypeID = 'Material Type is required';
    if (!material.materialID || material.materialID < 0) tempErrors.materialID = 'Material is required';
    if (!material.unitID) tempErrors.unitOfMeasure = 'Unit of Measure is required';
  
    if (isActuals) {
      if (!material.actualQuantity || material.actualQuantity < 0) tempErrors.actualQuantity = 'Actual Quantity must be greater than 0';
      if (!material.actualPricePerUnit || material.actualPricePerUnit < 0) tempErrors.actualPricePerUnit = 'Actual Price Per Unit must be greater than 0';
      if (!material.actualCostPerUnit || material.actualCostPerUnit < 0) tempErrors.actualCostPerUnit = 'Actual Cost Per Unit must be greater than 0';
      if (!material.actualMarkup || material.actualMarkup < 0) tempErrors.actualMarkup = 'Actual Markup must be greater than 0';
    } else {
      if (!material.budgetedQuantity || material.budgetedQuantity < 0) tempErrors.budgetedQuantity = 'Quantity must be greater than 0';
      if (!material.budgetedPricePerUnit || material.budgetedPricePerUnit < 0) tempErrors.budgetedPricePerUnit = 'Price Per Unit must be greater than 0';
      if (!material.budgetedCostPerUnit || material.budgetedCostPerUnit < 0) tempErrors.budgetedCostPerUnit = 'Cost Per Unit must be greater than 0';
      if (!material.budgetedMarkup || material.budgetedMarkup < 0) tempErrors.budgetedMarkup = 'Markup must be greater than 0';
    }
    setMaterialErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }
  
  const showConfirmationQuantity = () =>{
    MySwal.fire({
      title: '<strong>Are you sure?</strong>',
      html: '<span>The quantity entered exceeds available stock. Do you want to adjust quantity or proceed anyway?</span>',
      showCancelButton: true,
      // confirmButtonColor: "#F39C12",
      // cancelButtonColor: "#2E86DE",
      confirmButtonText: "Yes, Proceed!",
      cancelButtonText: "Adjust Quantity",
      allowEscapeKey: true,
       width: '390px', // Explicit width control
  padding: '1rem',
    focusConfirm: false,
     showCloseButton: true,
     closeButtonHtml: '&times;', // This is the × symbol
    customClass: {
     popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
    }).then((result) => {
      if (result.isConfirmed) {
        SaveMaterial();
      }
    });      
  }

  const fetchJobMaterials = async (workReqID) => {
    try {
      const data = await GetJobMaterials(workReqID, 0, jobID, navigate);      
      setJobMaterialList(
        data
          .filter(material => material.jobID === jobID)
          .map(({jobMaterialID, ...rest}) => ({
        id: jobMaterialID,
        jobMaterialID,
        ...rest,
          }))
      );
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  }
  const ResetMaterial = () => {
    setMaterial({
      ...initialMaterialState,
      jobID: jobID,
    });
  }
  const handleSaveJobMaterial = async () => {
    if (validateMaterialFields()) {      
      try {
        const duplicateMaterial = jobMaterialList.filter( x => x.materialID == material?.materialID)
        
        if(duplicateMaterial.length > 0 && LineItemContent?.Title === "Add Material"){ 
          toast.warning(`Material with same name already exists.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
          return;
        }else{
          if(material?.budgetedQuantity > material?.availableQuantity){
            showConfirmationQuantity();          
          }else{
            // console.log(material)
            SaveMaterial();
          }
        }                        
      } catch (error) {
        console.error('Error saving Material:', error);
      }
    }
  }

  useEffect(() => {
    if (openAddLineItem && LineItemContent.Type === "Material") {
      if (materialsList.length === 0) {
        fetchMaterials();
      }
    }
  }, [openAddLineItem, LineItemContent.Type]);
  
  useEffect(() => {
    if (openAddLineItem && LineItemContent.Type === "Asset" && assetTypesList.length > 0 && assetsList.length > 0) {
      // optionally re-hydrate the asset state
      setAsset(a => ({ ...a, assetTypeID: Number(a.assetTypeID) }));
    }
  }, [openAddLineItem, LineItemContent.Type, assetTypesList, assetsList]);


  useEffect(() => {
    if (openAddLineItem && LineItemContent.Type === "Material" && LineItemContent.Title === "Edit Material") {
      if (materialsList.length > 0) {
        const selectedMaterial = materialsList.find(item => item.materialID === material.materialID);
        if (selectedMaterial) {
          setMaterial((prevState) => ({ ...prevState, availableQuantity: selectedMaterial.quantityInStock}));
        }
      }
    }
  }, [openAddLineItem, LineItemContent.Type, materialsList,LineItemContent.Title]);


  const SaveMaterial = async () => {
    try {
      setLoading(true);
      const GetMaterial = materialsList.find((item) => item.materialID === material.materialID);
      
      // Determine budgeted values FIRST (matching Asset pattern)
      let budgetedFields = {
        budgetedQuantity: 0,
        budgetedCostPerUnit: 0,
        budgetedPricePerUnit: 0,
        budgetedMarkup: 0
      };
      
      if (isActuals) {
        // Fetch current budgeted values for edit operations
        const jobMaterials = await GetJobMaterials(workReq?.workReqID || 0, material.jobMaterialID, material.jobID, navigate);
        const current = Array.isArray(jobMaterials) ? jobMaterials.find(m => m.jobMaterialID === material.jobMaterialID) : null;
        if (current) {
          budgetedFields = {
            budgetedQuantity: current.budgetedQuantity ?? 0,
            budgetedCostPerUnit: current.budgetedCostPerUnit ?? 0,
            budgetedPricePerUnit: current.budgetedPricePerUnit ?? 0,
            budgetedMarkup: current.budgetedMarkup ?? 0,
          };
        }
        // If no current (new material), stays 0
      } else {
        // Use form values for budgeted mode
        budgetedFields = {
          budgetedQuantity: Number(material.budgetedQuantity) || 0,
          budgetedCostPerUnit: Number(material.budgetedCostPerUnit) || 0,
          budgetedPricePerUnit: Number(material.budgetedPricePerUnit) || 0,
          budgetedMarkup: Number(material.budgetedMarkup) || 0,
        };
      }
      
      // Build payload once with correct data
      const payloadJobMaterial = {
        jobMaterialID: material.jobMaterialID || 0,
        jobID: material.jobID,
        materialID: Number(material.materialID) || 0,
        materialTypeID: Number(material.materialTypeID) || 0,
        sku: material.sku || "",
        unitID: GetMaterial?.unitID || material.unitID,
        ...budgetedFields,
        ...(isActuals ? {
          actualQuantity: Number(material.actualQuantity) || 0,
          actualCostPerUnit: Number(material.actualCostPerUnit) || 0,
          actualPricePerUnit: Number(material.actualPricePerUnit) || 0,
          actualMarkup: Number(material.actualMarkup) || 0,
        } : {}),
        providedBy: Number(material.providedBy) || 0,
        sortOrder: Number(material.sortOrder) || 0,
        notes: material.notes || ""
      };

      console.log('Saving material with payload:', payloadJobMaterial); // Debug log

      const result = await SaveJobMaterial(payloadJobMaterial, navigate);
      if (result && !result.isError) {
        setOpenAddLineItem(false);
        toast.success(`Material saved successfully.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      } else {
        // Show error message from the server or a default one
        toast.error(result?.message || 'Failed to save material', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    } catch (error) {
      console.error('Error saving Material:', error);
      toast.error('An error occurred while saving the material', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
    } finally {
      setLoading(false);
      fetchJobMaterials(workReq?.workReqID);
      ResetMaterial();
    }
  };
  
  const handleJobMaterialEdit = (jobMaterial) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit Material",
      Type: "Material",
    });
    // Ensure all numeric values are properly converted and defaulted
    const processedMaterial = {
      ...initialMaterialState,
      ...jobMaterial,
      materialTypeID: Number(jobMaterial.materialTypeID) || 0,
      materialID: Number(jobMaterial.materialID) || 0,
      // Budgeted values
      budgetedQuantity: Number(jobMaterial.budgetedQuantity) || 0,
      budgetedCostPerUnit: Number(jobMaterial.budgetedCostPerUnit) || 0,
      budgetedPricePerUnit: Number(jobMaterial.budgetedPricePerUnit) || 0,
      budgetedMarkup: Number(jobMaterial.budgetedMarkup) || 0,
      // Actual values
      actualQuantity: Number(jobMaterial.actualQuantity) || 0,
      actualCostPerUnit: Number(jobMaterial.actualCostPerUnit) || 0,
      actualPricePerUnit: Number(jobMaterial.actualPricePerUnit) || 0,
      actualMarkup: Number(jobMaterial.actualMarkup) || 0,
      // Other fields
      unitID: jobMaterial.unitID || "",
      providedBy: Number(jobMaterial.providedBy) || 0,
      sku: jobMaterial.sku || "",
      notes: jobMaterial.notes || "",
      sortOrder: Number(jobMaterial.sortOrder) || 0,
      // Preserve available quantity for stock checking
      availableQuantity: Number(jobMaterial.availableQuantity) || 0
    };
    setMaterial(processedMaterial);
  };
  
  const handleJobMaterialDelete = async (jobMaterialID) => {
    if (jobMaterialID) {
      try {
        const result = await DeleteJobMaterial(jobMaterialID, jobID, navigate);
        if (result && !result.isError) {
          fetchJobMaterials(workReq?.workReqID);
          toast.success(`Material removed successfully.`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting Material:', error);
      }
    }
  }  
  const fetchMaterials = async () => {
    try {
      const data = await GetMaterials(0, navigate);
      setMaterialsList(data);
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  }
  useEffect(() => {
    if (Object.keys(materialErrors).length > 0) {
      const timer = setTimeout(() => {
        setMaterialErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [materialErrors]);

  //#endregion End Material Handlers

  //#region Subcontractor Handlers

  const handleSubcontractorChange = (field, value) => {
     if (isActuals) {
      if (field.startsWith('actual')) {
        setSubcontractor((prevState) => { 
          const newState = { ...prevState, [field]: value };
          
          if (field === 'actualCostPerUnit') {
            const cost = parseFloat(value) || 0;
            const markup = newState.actualMarkup || 0;
            const price = cost * (1 + markup / 100);
            newState.actualPricePerUnit = price;
          } 
          else if (field === 'actualPricePerUnit') {
            const cost = newState.actualCostPerUnit || 0;
            const price = parseFloat(value) || 0;
            const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
            newState.actualMarkup = Math.round(markup);
          } 
          else if (field === 'actualMarkup') {
            const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
            if (isValidInput) {
              newState.actualMarkup = value;
            } else {
              return prevState;
            }
            const cost = newState.actualCostPerUnit || 0;
            const markupValue = parseFloat(newState.actualMarkup) || 0;
            const price = cost * (1 + markupValue / 100);
            newState.actualPricePerUnit = price;
          }
          // else if ((field === 'unitType') && (value === 'Per Job' || value === 'Salary')){
          //   newState.actualUnitQuantity = 1;
          //   newState.unitType = value;
          // }
          
          return newState;
        });
        return;
      }
    }

    if (field === 'skillID') {
      if (value) {
        setSubcontractor((prevState) => ({
          ...prevState,
          [field]: value,
          employeeID: 0,
          budgetedCostPerUnit: skillTypesList?.find(item => item.skillID === value).avgHourlyRate,
          providedBy: 0
        }));
      } else {
        setSubcontractor((prevState) => ({ ...prevState, [field]: value, employeeID: 0 }));
      }
    } 
    // else if (field === 'employeeID') {
    //   const selectedEmployee = subcontractorList.find(emp => emp.employeeID === value);
    //   if (selectedEmployee) {
    //     setSubcontractor((prevState) => ({
    //       ...prevState,
    //       [field]: value,
    //       unitType: selectedEmployee.wageType,
    //       budgetedCostPerUnit: selectedEmployee.wageType === 'Salaried' ? 0 : selectedEmployee.wageAmount,
    //       budgetedUnitQuantity: 1
    //     }));
    //   } else if (value === 0) {
    //     setSubcontractor((prevState) => ({
    //       ...prevState,
    //       [field]: value,
    //       budgetedCostPerUnit: skillTypesList?.find(item => item.skillID === prevState.skillID)?.avgHourlyRate || 0
    //     }));
    //   }
    // } 
    else if (field === 'budgetedUnitQuantity') {
      if (isNumberOnly(value)) {
        setSubcontractor((prevState) => ({ ...prevState, [field]: value }));
      }
    } else if (field === 'budgetedCostPerUnit') {
      if (isNumberOnly(value)) {
        setSubcontractor((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.budgetedMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price 
          };
        });
      }
    } else if (field === 'budgetedPricePerUnit') {
      if (isNumberOnly(value)) {
        setSubcontractor((prevState) => {
          const cost = prevState.budgetedCostPerUnit || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, budgetedMarkup: Math.round(markup) };
        });
      }
    } else if (field === 'budgetedMarkup') {
      const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
      if (isValidInput) {
        setSubcontractor((prevState) => {
          const cost = prevState.budgetedCostPerUnit || 0;
          const markupValue = parseFloat(value) || 0;
          const price = cost * (1 + markupValue / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price 
          };
        });
      }
    } 
    // else if ((field === 'unitType') && (value === 'Per Job' || value === 'Salary')) {
    //   setSubcontractor((prevState) => ({
    //     ...prevState,
    //     [field]: value,
    //     budgetedUnitQuantity: 1
    //   }));
    // } 
    else {
      setSubcontractor((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const validateSubcontractorFields = () => {
    let tempErrors = {};

    // always required
    if (!subcontractor.skillID || subcontractor.skillID < 0) {
      tempErrors.skillID = 'Skill Type is required';
    }
    if (!subcontractor.employeeID || subcontractor.employeeID < 0) {
      tempErrors.employeeID = 'Subcontractor is required';
    }
    if (!subcontractor.unitID) { 
      tempErrors.unitID = 'Unit of Measure is required';
    }

    if (isActuals) {
      // actual mode
      if (!subcontractor.actualUnitQuantity) {
        tempErrors.actualUnitQuantity = 'Unit Quantity must be greater than 0';
      }
      if (!subcontractor.actualCostPerUnit) {
        tempErrors.actualCostPerUnit = 'Actual Cost Per Unit must be greater than 0';
      }
      if (!subcontractor.actualPricePerUnit) {
        tempErrors.actualPricePerUnit = 'Actual Price Per Unit must be greater than 0';
      }
      if (!subcontractor.actualMarkup) {
        tempErrors.actualMarkup = 'Actual Markup must be greater than 0';
      }
    } else {
      // budgeted mode
      if (!subcontractor.budgetedUnitQuantity) {
        tempErrors.budgetedUnitQuantity = 'Unit Quantity must be greater than 0';
      }
      if (!subcontractor.budgetedCostPerUnit) {
        tempErrors.budgetedCostPerUnit = 'Budgeted Cost Per Unit must be greater than 0';
      }
      if (!subcontractor.budgetedPricePerUnit) {
        tempErrors.budgetedPricePerUnit = 'Budgeted Price Per Unit must be greater than 0';
      }
      if (!subcontractor.budgetedMarkup) {
        tempErrors.budgetedMarkup = 'Budgeted Markup must be greater than 0';
      }
    }

    setSubcontractorErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchJobSubcontractors = async (workReqID) => {
    try {
      const data = await GetJobSubcontractor(workReqID, 0, jobID, navigate);
      setJobSubcontractorList(
        data
          .filter(subcontractor => subcontractor.jobID === jobID)
          .map(({jobSubcontractorID, ...rest}) => ({
            id: jobSubcontractorID,
            jobSubcontractorID,
            ...rest,
          }))
      );
    } catch (error) {
      console.error('Error fetching subcontractors:', error);
    }
  };

  const fetchSubcontractorList = async () => {
    try {
      const data = await GetSubcontractors(0, navigate);
      setSubcontractorList(data);
    } catch (error) {
      console.error('Error fetching subcontractors:', error);
    }
  };

  const ResetSubcontractor = () => {
    setSubcontractor({
      ...initialSubcontractorState,
      jobID: jobID,
    });
  };

  const handleSaveJobSubcontractor = async () => {
    if (!validateSubcontractorFields()) return; // Return if basic validation fails

    // Check for duplicates
    const duplicateEntry = jobSubcontractorList?.some(x => {
      const sameSkill = x.skillID === subcontractor?.skillID;
      const employeeCheck =
        (x.employeeID === subcontractor?.employeeID) || // Same employee
        (x.employeeID === null && subcontractor?.employeeID === 0) || // Both have no employee
        (subcontractor?.employeeID === null && x.employeeID === 0); // Reverse case

      return sameSkill && (subcontractor?.employeeID !== 0 ? employeeCheck : true);
    });

    if (duplicateEntry && LineItemContent?.Title === "Add Subcontractor") {
      const message = subcontractor?.employeeID !== 0
        ? "Subcontractor with same name and skill already exists."
        : "This skill type already exists in the list.";

      toast.warning(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return;
    }

    setLoading(true);
    try {
      let budgetedFields = {
        budgetedUnitQuantity: 0,
        budgetedCostPerUnit: 0,
        budgetedPricePerUnit: 0,
        budgetedMarkup: 0,
      };
      if (isActuals) {
        // Fetch current budgeted values for this labor
        const jobSubcontractor = await GetJobSubcontractor(workReq?.workReqID || 0, subcontractor.jobSubcontractorID, subcontractor.jobID, navigate);
        const current = Array.isArray(jobSubcontractor) ? jobSubcontractor.find(l => l.jobSubcontractorID === subcontractor.jobSubcontractorID) : null;
        if (current) {
          budgetedFields = {
            budgetedUnitQuantity: current.budgetedUnitQuantity ?? 0,
            budgetedCostPerUnit: current.budgetedCostPerUnit ?? 0,
            budgetedPricePerUnit: current.budgetedPricePerUnit ?? 0,
            budgetedMarkup: current.budgetedMarkup ?? 0,
          };
        }
      } else {
        budgetedFields = {
          budgetedUnitQuantity: subcontractor.budgetedUnitQuantity,
          budgetedCostPerUnit: subcontractor.budgetedCostPerUnit,
          budgetedPricePerUnit: subcontractor.budgetedPricePerUnit,
          budgetedMarkup: subcontractor.budgetedMarkup,
        };
      }

      const payloadJobSubcontractor = {
        jobSubcontractorID: subcontractor.jobSubcontractorID,
        jobID: subcontractor.jobID,
        skillID: subcontractor.skillID,
        employeeID: subcontractor.employeeID,
        teamID: subcontractor.teamID,
        unitID: subcontractor.unitID,
        ...budgetedFields,
        ...(isActuals ? {
          actualUnitQuantity: subcontractor.actualUnitQuantity,
          actualCostPerUnit: subcontractor.actualCostPerUnit,
          actualPricePerUnit: subcontractor.actualPricePerUnit,
          actualMarkup: subcontractor.actualMarkup,
        } : {}),
        providedBy: subcontractor.providedBy,
        sortOrder: subcontractor.sortOrder,
        notes: subcontractor.notes
      };
      const result = await SaveJobSubcontractor(payloadJobSubcontractor, navigate, isActuals);
      if (result && !result.isError) {

        const newSubcontractorRow = {
          id:          result?.result?.jobSubcontractorID,
          jobSubcontractorID:  result?.result?.jobSubcontractorID,
          jobID:       payloadJobSubcontractor.jobID,
          skillID:     payloadJobSubcontractor.skillID,
          employeeID:  payloadJobSubcontractor.employeeID,
          teamID:      payloadJobSubcontractor.teamID,
          budgetedUnitQuantity: payloadJobSubcontractor.budgetedUnitQuantity,
          budgetedCostPerUnit: payloadJobSubcontractor.budgetedCostPerUnit,
          budgetedPricePerUnit: payloadJobSubcontractor.budgetedPricePerUnit,
          budgetedMarkup: payloadJobSubcontractor.budgetedMarkup,
          providedBy:          payloadJobSubcontractor.providedBy,
          sortOrder:           payloadJobSubcontractor.sortOrder,
          notes:               payloadJobSubcontractor.notes,
        }
  
        setJobSubcontractorList(curr => [...curr, newSubcontractorRow])

        setOpenAddLineItem(false);
        toast.success(`Subcontractor saved successfully.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    } catch (error) {
      console.error('Error saving Subcontractor:', error);
    } finally {
      setLoading(false);
      fetchJobSubcontractors(workReq?.workReqID);
      ResetSubcontractor();
    }
  };

  const handleJobSubcontractorEdit = (jobSubcontractor) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit Subcontractor",
      Type: "Subcontractor",
    });
    setSubcontractor({
      ...initialSubcontractorState,
      ...jobSubcontractor,
      jobSubcontractorID: jobSubcontractor.jobSubcontractorID,
      skillID: jobSubcontractor.skillID,
      employeeID: jobSubcontractor.employeeID,
      budgetedUnitQuantity: jobSubcontractor.budgetedUnitQuantity ?? 0,
      budgetedCostPerUnit: jobSubcontractor.budgetedCostPerUnit ?? 0,
      budgetedPricePerUnit: jobSubcontractor.budgetedPricePerUnit ?? 0,
      budgetedMarkup: jobSubcontractor.budgetedMarkup ?? 0,
      actualUnitQuantity: jobSubcontractor.actualUnitQuantity ?? 0,
      actualCostPerUnit: jobSubcontractor.actualCostPerUnit ?? 0,
      actualPricePerUnit: jobSubcontractor.actualPricePerUnit ?? 0,
      actualMarkup: jobSubcontractor.actualMarkup ?? 0,
      providedBy: jobSubcontractor.providedBy ?? 0,
    });
  };
  
  const handleJobSubcontractorDelete = async (jobSubcontractorID) => {
    if (!jobSubcontractorID) return;
    try {
      const result = await DeleteJobSubcontractor(jobSubcontractorID, jobID, navigate);
      if (result && !result.isError) {
        setJobSubcontractorList(curr => curr.filter(l => l.jobSubcontractorID !== jobSubcontractorID));
  
        toast.success(`Subcontractor removed successfully.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
  
        fetchJobSubcontractors(workReq?.workReqID);
      }
    } catch (error) {
      console.error('Error deleting Subcontractor:', error);
    }
  };
   
  useEffect(() => {
    if (Object.keys(subcontractorErrors).length > 0) {
      const timer = setTimeout(() => {
        setJobSubcontractorList({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [subcontractorErrors]);

  //#endregion End Subcontractor Handlers

  //#region Labor Handlers

  // const handleLaborChange = (field, value) => {
  //   if (isActuals) {
  //     const actualFieldMap = {
  //       budgetedHours: 'actualHours',
  //       budgetedCostPerHour: 'actualCostPerHour'
  //     };
  //     if (actualFieldMap[field]) {
  //       setLabor((prevState) => ({ ...prevState, [actualFieldMap[field]]: value }));
  //       return;
  //     }
  //   }
    
  //   if (field === 'skillID') {
  //     if (value) {
  //       setLabor((prevState) => {
  //         const currentEmployee = employeeList.find(emp => emp.employeeID === prevState.employeeID);
  //         const shouldClearEmployee = currentEmployee && currentEmployee.skillID !== value;
          
  //         return {
  //           ...prevState,
  //           [field]: value,
  //           employeeID: shouldClearEmployee ? 0 : prevState.employeeID, 
  //           budgetedCostPerHour: skillTypesList?.find(item => item.skillID === value)?.avgHourlyRate || 0,
  //           providedBy: shouldClearEmployee ? 0 : prevState.providedBy
  //         };
  //       });
  //     } else {
  //       setLabor((prevState) => ({ 
  //         ...prevState, 
  //         [field]: 0,
  //       }));
  //     }
  //   } else if (field === 'employeeID') {
  //     const selectedEmployee = employeeList.find(emp => emp.employeeID === value);
      
  //     if (selectedEmployee) {
  //       setLabor((prevState) => ({
  //         ...prevState,
  //         [field]: value,
  //         skillID: selectedEmployee.skillID || prevState.skillID, 
  //         budgetedCostPerHour: selectedEmployee.hourlyRate,
  //         wageType: selectedEmployee.wageType
  //       }));
  //     } else if (value === 0) {
  //       setLabor((prevState) => ({
  //         ...prevState,
  //         [field]: value,
  //         budgetedCostPerHour: 0
  //       }));
  //     }
  //   } else if (field === 'budgetedHours') {
  //     if (isNumberOnly(value)) {
  //       setLabor((prevState) => ({ ...prevState, [field]: value }));
  //     }
  //   } else if (field === 'markup') {
  //     const isValidNumber = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
  //     if (isValidNumber) {
  //       setLabor((prevState) => ({ ...prevState, [field]: value }));
  //     }
  //   } else {
  //     setLabor((prevState) => ({ ...prevState, [field]: value }));
  //   }
  // };

  const handleLaborChange = (field, value) => {
    if (isActuals) {
      if (field.startsWith('actual')) {
        setLabor((prevState) => { 
          const newState = { ...prevState, [field]: value };
          
          if (field === 'actualCostPerHour') {
            const cost = parseFloat(value) || 0;
            const markup = newState.actualMarkup || 0;
            const price = cost * (1 + markup / 100);
            newState.actualPricePerUnit = price.toFixed(2);
          } 
          else if (field === 'actualPricePerUnit') {
            const cost = newState.actualCostPerHour || 0;
            const price = parseFloat(value) || 0;
            const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
            newState.actualMarkup = Math.round(markup);
          } 
          else if (field === 'actualMarkup') {
            const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
            if (isValidInput) {
              newState.actualMarkup = value;
            } else {
              return prevState;
            }
            const cost = newState.actualCostPerHour || 0;
            const markupValue = parseFloat(newState.actualMarkup) || 0;
            const price = cost * (1 + markupValue / 100);
            newState.actualPricePerUnit = price.toFixed(2);
          }  else if (field === 'actualHours') {
            if(isNumberOnly(value)){
              setLabor((prevState) => ({ ...prevState, [field]: value }));  
            }
          }
          
          return newState;
        });
        return;
      }
    }

    if (field === 'skillID') {
      if (value) {
        setLabor((prevState) => {
          const currentEmployee = employeeList.find(emp => emp.employeeID === prevState.employeeID);
          const shouldClearEmployee = currentEmployee && currentEmployee.skillID !== value;
          
          return {
            ...prevState,
            [field]: value,
            employeeID: shouldClearEmployee ? 0 : prevState.employeeID, 
            budgetedCostPerHour: skillTypesList?.find(item => item.skillID === value)?.avgHourlyRate || 0,
            providedBy: shouldClearEmployee ? 0 : prevState.providedBy
          };
        });
      } else {
        setLabor((prevState) => ({ 
          ...prevState, 
          [field]: 0,
        }));
      }
    } else if(field === 'employeeID'){
      const selectedEmployee = employeeList.find(emp => emp.employeeID === value);
      
      if (selectedEmployee) {
        setLabor((prevState) => ({
          ...prevState,
          [field]: value,
          skillID: selectedEmployee.skillID || prevState.skillID, 
          budgetedCostPerHour: selectedEmployee.hourlyRate,
          wageType: selectedEmployee.wageType
        }));
      } else if (value === 0) {
        setLabor((prevState) => ({
          ...prevState,
          [field]: value,
          budgetedCostPerHour: 0
        }));
      }
    } else if (field === 'budgetedCostPerHour') {
      if (isNumberOnly(value)) {
        setLabor((prevState) => {
          const cost = parseFloat(value) || 0;
          const markup = prevState.budgetedMarkup || 0;
          const price = cost * (1 + markup / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price.toFixed(2)
          };
        });
      }
    } else if (field === 'budgetedPricePerUnit') {
      if (isNumberOnly(value)) {
        setLabor((prevState) => {
          const cost = prevState.budgetedCostPerHour || 0;
          const price = parseFloat(value) || 0;
          const markup = cost > 0 ? ((price - cost) / cost) * 100 : 0;
          return { ...prevState, [field]: value, budgetedMarkup: Math.round(markup) };
        });
      }
    } else if (field === 'budgetedMarkup') {
      const isValidInput = /^[0-9]*\.?[0-9]*$/.test(value) || value === '';
      
      if (isValidInput) {
        setLabor((prevState) => {
          const cost = prevState.budgetedCostPerHour || 0;
          const markupValue = parseFloat(value) || 0;
          const price = cost * (1 + markupValue / 100);
          return { 
            ...prevState, 
            [field]: value, 
            budgetedPricePerUnit: price.toFixed(2)
          };
        });
      }
    } else if (field === 'budgetedHours') {
      if(isNumberOnly(value)){
        setLabor((prevState) => ({ ...prevState, [field]: value }));  
      }
    }
    else {
      setLabor((prevState) => ({ ...prevState, [field]: value }));
    }
  };
  
  const validateLaborFields = () => {
    let tempErrors = {};

    // always required
    // if (!labor.skillID || labor.skillID < 0) {
    //   tempErrors.skillID = 'Skill Type is required';
    // }

    if (isActuals) {
      // actual mode
      if (!labor.actualHours || labor.actualHours <= 0) {
        tempErrors.actualHours = 'Actual Labor Hours must be greater than 0';
      }
      if (!labor.actualCostPerHour || labor.actualCostPerHour <= 0) {
        tempErrors.actualCostPerHour = 'Actual Cost Per Hour must be greater than 0';
      }
      if (!labor.actualPricePerUnit || labor.actualPricePerUnit <= 0) {
        tempErrors.actualPricePerUnit = 'Actual Price Per Hour must be greater than 0';
      }
      if (!labor.actualMarkup || labor.actualMarkup <= 0) {
        tempErrors.actualMarkup = 'Actual Markup must be greater than 0';
      }
    } else {
      // budgeted mode
      if (!labor.budgetedHours || labor.budgetedHours <= 0) {
        tempErrors.budgetedHours = 'Labor Hours must be greater than 0';
      }
      if (!labor.budgetedCostPerHour || labor.budgetedCostPerHour <= 0) {
        tempErrors.budgetedCostPerHour = 'Cost Per Hour must be greater than 0';
      }
      if (!labor.budgetedPricePerUnit || labor.budgetedPricePerUnit <= 0) {
        tempErrors.budgetedPricePerUnit = 'Price Per Hour must be greater than 0';
      }
      if (!labor.budgetedMarkup || labor.budgetedMarkup <= 0) {
        tempErrors.budgetedMarkup = 'Markup must be greater than 0';
      }
    }

    setLaborErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchJobLabors = async (workReqID) => {
    try {
      const data = await GetJobLabors(workReqID, 0, jobID, navigate);
      setJobLaborList(
        data
          .filter(labor => labor.jobID === jobID)
          .map(({jobLaborID, ...rest}) => ({
        id: jobLaborID,
        jobLaborID,
        ...rest,
          }))
      );
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  };

  const fetchEmployeeList = async () => {
    try {
      const data = await GetEmployees(0, navigate);
      setEmployeeList(data);
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  };

  const fetchSkillTypes = async () => {
    try {
      const data = await GetSkills(0, navigate);
      setSkillTypesList(data);
    } catch (error) {
      console.error('Error fetching assets:', error);
    }
  };

  const ResetLabor = () => {
    setLabor({
      ...initialLaborState,
      jobID: jobID,
    });
  };

  const handleSaveJobLabor = async () => {
    if (!validateLaborFields()) return; // Return if basic validation fails

    // Check for duplicates
    const duplicateEntry = jobLaborList.some(x => {
      const sameSkill = x.skillID === labor?.skillID;
      const employeeCheck =
        (x.employeeID === labor?.employeeID) || // Same employee
        (x.employeeID === null && labor?.employeeID === 0) || // Both have no employee
        (labor?.employeeID === null && x.employeeID === 0); // Reverse case

      return sameSkill && (labor?.employeeID !== 0 ? employeeCheck : true);
    });

    if (duplicateEntry && LineItemContent?.Title === "Add Laborer") {
      const message = labor?.employeeID !== 0
        ? "Laborer with same name and skill already exists."
        : "This skill type already exists in the list.";

      toast.warning(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return;
    }

    setLoading(true);
    try {
      let budgetedFields = {
        budgetedCostPerHour: 0,
        budgetedPricePerUnit: 0,
        budgetedHours: 0,
        budgetedMarkup: 0,
      };
      if (isActuals) {
        // Fetch current budgeted values for this labor
        const jobLabors = await GetJobLabors(workReq?.workReqID || 0, labor.jobLaborID, labor.jobID, navigate);
        const current = Array.isArray(jobLabors) ? jobLabors.find(l => l.jobLaborID === labor.jobLaborID) : null;
        if (current) {
          budgetedFields = {
            budgetedCostPerHour: current.budgetedCostPerHour ?? 0,
            budgetedPricePerUnit: current.budgetedPricePerUnit ?? 0,
            budgetedHours: current.budgetedHours ?? 0,
            budgetedMarkup: current.budgetedMarkup ?? 0,
          };
        }
      } else {
        budgetedFields = {
          budgetedCostPerHour: labor.budgetedCostPerHour,
          budgetedPricePerUnit: labor.budgetedPricePerUnit,
          budgetedHours: labor.budgetedHours,
          budgetedMarkup: labor.budgetedMarkup,
        };
      }
      const payloadJobLabor = {
        jobLaborID: labor.jobLaborID,
        jobID: labor.jobID,
        skillID: labor.skillID,
        employeeID: labor.employeeID,
        teamID: labor.teamID,
        ...budgetedFields,
        ...(isActuals ? {
          actualCostPerHour: labor.actualCostPerHour,
          actualPricePerUnit: labor.actualPricePerUnit,
          actualHours: labor.actualHours,
          actualMarkup: labor.actualMarkup,
        } : {}),
        markup: labor.markup,
        providedBy: labor.providedBy,
        sortOrder: labor.sortOrder,
        notes: labor.notes
      };
      const result = await SaveJobLabor(payloadJobLabor, navigate, isActuals);
      if (result && !result.isError) {

        const newLaborRow = {
          id:          result?.result?.jobLaborID,       // <-- DataGrid’s required id
          jobLaborID:  result?.result?.jobLaborID,       // your PK
          jobID:       payloadJobLabor.jobID,
          skillID:     payloadJobLabor.skillID,
          employeeID:  payloadJobLabor.employeeID,
          teamID:      payloadJobLabor.teamID,
          budgetedCostPerHour: payloadJobLabor.budgetedCostPerHour,
          budgetedPricePerUnit: payloadJobLabor.budgetedPricePerUnit,
          budgetedHours:       payloadJobLabor.budgetedHours,
          budgetedMarkup:       payloadJobLabor.budgetedMarkup,
          providedBy:          payloadJobLabor.providedBy,
          sortOrder:           payloadJobLabor.sortOrder,
          notes:               payloadJobLabor.notes,
          // if you display skillType or employeeName in your grid columns,
          // add them here as well:
          // skillType: yourSkillLookup[payloadJobLabor.skillID],
          // employeeName: yourEmployeeLookup[payloadJobLabor.employeeID],
        }
  
        // 4) Optimistically insert it
        setJobLaborList(curr => [...curr, newLaborRow])

        setOpenAddLineItem(false);
        toast.success(`Laborer saved successfully.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }
    } catch (error) {
      console.error('Error saving Labor:', error);
    } finally {
      setLoading(false);
      fetchJobLabors(workReq?.workReqID);
      ResetLabor();
    }
  };

  const handleJobLaborEdit = (jobLabor) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit Laborer",
      Type: "Labor",
    });
    setLabor({
      ...initialLaborState,
      ...jobLabor,
      skillID: jobLabor.skillID,
      employeeID: jobLabor.employeeID,
      budgetedCostPerHour: jobLabor.budgetedCostPerHour ?? 0,
      budgetedPricePerUnit: jobLabor.budgetedPricePerUnit ?? 0,
      budgetedHours: jobLabor.budgetedHours ?? 0,
      budgetedMarkup: jobLabor.budgetedMarkup ?? 0,
      actualCostPerHour: jobLabor.actualCostPerHour ?? 0,
      actualPricePerUnit: jobLabor.actualPricePerUnit ?? 0,
      actualHours: jobLabor.actualHours ?? 0,
      actualMarkup: jobLabor.actualMarkup ?? 0,
      providedBy: jobLabor.providedBy ?? 0,
    });
  };
  
  const handleJobLaborDelete = async (jobLaborID) => {
    if (!jobLaborID) return;
    try {
      const result = await DeleteJobLabor(jobLaborID, jobID, navigate);
      if (result && !result.isError) {
        // 1) Optimistically remove from local state
        setJobLaborList(curr => curr.filter(l => l.jobLaborID !== jobLaborID));
  
        toast.success(`Laborer removed successfully.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
  
        // 2) Re-sync with server in case anything drifted
        fetchJobLabors(workReq?.workReqID);
      }
    } catch (error) {
      console.error('Error deleting Labor:', error);
    }
  };
   
  useEffect(() => {
    if (Object.keys(laborErrors).length > 0) {
      const timer = setTimeout(() => {
        setLaborErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [laborErrors]);

  //#endregion End Labor Handlers

  //Other Costs Handlers
  //End Other Costs Handlers

  //General Handlers

  useEffect(() => {
    // console.log("TRIGGERED useEffect", {
    //   workReqID: workReq?.workReqID,
    //   jobID: job?.jobID,
    // });
    if (workReq?.workReqID || job?.jobID) {
      fetchTypeCatalog();
      fetchAssets();
      fetchMaterials();
      fetchEmployeeList();
      fetchSkillTypes();
      fetchSubcontractorList();
      fetchJobObservations(workReq?.workReqID);
      fetchJobAssets(workReq?.workReqID);
      fetchJobLabors(workReq?.workReqID);
      fetchJobSubcontractors(workReq?.workReqID);
      fetchJobMaterials(workReq?.workReqID); 
      fetchJobMiscCosts(workReq?.workReqID); 
       fetchUnitsData();
    }

  }, [workReq?.workReqID, job?.jobID]);
  // [workReq, job]);

  const fetchUnitsData = async () => {
    try {
      const unitsResponse = await getUnits();
      if (!unitsResponse.isError && unitsResponse.result) {
        const formattedUnits = unitsResponse.result.map(unit => {
          const symbol = unit.unitSymbol || ''; 
          const unitName = unit.unitName || '';
          const unitID = unit.unitID;
          
          let label = '';
          
          label = `${unitName}${symbol ? ` (${symbol})` : ''}`
          
          return {
            value: unit.unitID,
            label: label,
            originalData: unit
          };
        });
        
        setUnits(formattedUnits);
      } else {
        console.error("Failed to load units:", unitsResponse.message);
      //   toast.error("Failed to load units", {
      //   style: {
      //     fontFamily: '"DM Sans", sans-serif',
      //     fontSize: '15px',
      //   },
      // });
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      toast.error("Error loading units", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    }
  };

  // Add handleUnitCreated function
  const handleUnitCreated = async (newUnit) => {
    console.log("Unit created callback:", newUnit);  
    await fetchUnitsData();
    if (newUnit && newUnit.result) {
      const createdUnit = newUnit.result;
      const unitValue = createdUnit.unitID;
      
      if (unitValue) {
        setMaterial(prevForm => ({
          ...prevForm,
          unitID: unitValue
        }));
      }
    }
  };

  const handleSave = async (Type) => {
    // Ask confirmation only in Actuals mode
  if (
      isActuals &&
      (LineItemContent?.Title?.startsWith("Edit")) 
    ) {
      const confirmed = await  MySwal.fire({
      title: '<strong>Are you sure?</strong>',
      html: '<span>Do you want to update the Actual Job Data?</span>',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'Cancel',
      width: '400px', 
      padding: '1rem',
      focusConfirm: false,
      showCloseButton: true,
      closeButtonHtml: '&times;',
      customClass: {
        popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
        title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
        htmlContainer: 'custom-swal-html',
        confirmButton: 'custom-swal-confirm',
        cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
        closeButton: 'custom-swal-close'
      }
    }).then((result) => result.isConfirmed);

      if (!confirmed) return; 
    }

    switch (Type) {
      case "Asset":
        handleSaveJobAsset();
        break;
      case "Material":
        handleSaveJobMaterial();
        break;
      case "Labor":
        handleSaveJobLabor();
        break;
      case "Observation":
        handleSaveJobObservation();
        break;
      case "Subcontractor":
        handleSaveJobSubcontractor();
        break;
      case "MiscCost":
        handleSaveJobMiscCost();
        break;
      default:
        break;
    }
  };

  //#endregion end of handlers and methods

  //#region MiscCost
  const handleMiscCostChange = (field, value) => {
    if (isActuals) {
      // Map budgeted field names to actuals
      const actualFieldMap = {
        budgetedCustomerPrice: 'actualCustomerPrice',
        budgetedCostAmount: 'actualCostAmount'
      };
      if (actualFieldMap[field]) {
        setMiscCost((prevState) => ({ ...prevState, [actualFieldMap[field]]: value }));
        return;
      }
    }
  
    if (field === 'budgetedCustomerPrice' || field === 'budgetedCostAmount') {
      if (isNumberOnly(value)) {
        setMiscCost((prevState) => ({ ...prevState, [field]: value }));
      }
    } else {
      setMiscCost((prevState) => ({ ...prevState, [field]: value }));
    }
  };
  

  // const validateMiscCostFields = () => {
  //   let tempErrors = {};
  //   if (!miscCost.costName) tempErrors.costName = 'Other Cost is required';
  //   //if (!miscCost.costDescription) tempErrors.costDescription = 'Description is required';
  //   if (!miscCost.budgetedCostAmount || miscCost.budgetedCostAmount < 0) tempErrors.budgetedCostAmount = 'Cost Amount must be greater than 0';
  //   if ((!miscCost.budgetedCustomerPrice || miscCost.budgetedCustomerPrice < 0) && miscCost.billToCustomer) tempErrors.budgetedCustomerPrice = 'Customer Price must be greater than 0';    
  //   setMiscCostErrors(tempErrors);
  //   return Object.keys(tempErrors).length === 0;
  // }

  // -------------------------------
// Validate Misc Cost
// -------------------------------
const validateMiscCostFields = () => {
  let tempErrors = {};

  if (!miscCost.costName) {
    tempErrors.costName = 'Other Cost is required';
  }

  if (isActuals) {
    // actual mode
    if (!miscCost.actualCostAmount || miscCost.actualCostAmount <= 0) {
      tempErrors.actualCostAmount = 'Cost Amount must be greater than 0';
    }
    if (
      (!miscCost.actualCustomerPrice || miscCost.actualCustomerPrice <= 0) &&
      miscCost.billToCustomer
    ) {
      tempErrors.actualCustomerPrice = 'Customer Price must be greater than 0';
    }
  } else {
    // budgeted mode
    if (!miscCost.budgetedCostAmount || miscCost.budgetedCostAmount <= 0) {
      tempErrors.budgetedCostAmount = 'Cost Amount must be greater than 0';
    }
    if (
      (!miscCost.budgetedCustomerPrice || miscCost.budgetedCustomerPrice <= 0) &&
      miscCost.billToCustomer
    ) {
      tempErrors.budgetedCustomerPrice = 'Customer Price must be greater than 0';
    }
  }

  setMiscCostErrors(tempErrors);
  return Object.keys(tempErrors).length === 0;
};

  const fetchJobMiscCosts = async (workReqID) => {
    try {
      const data = await GetJobMiscCosts(workReqID, 0, jobID, navigate);      
      setJobMiscCostList(
        data
          .filter(misc => misc.jobID === jobID)
          .map(({miscCostID, ...rest}) => ({
        id: miscCostID,
        miscCostID,
        ...rest,
          }))
      );
    } catch (error) {
      console.error('Error fetching MiscCosts:', error);
    }
  }

  const ResetMiscCost = () => {
    setMiscCost({
      ...initialMiscCostState,
      jobID: jobID,
    });
  }

  const handleJobMiscCostEdit = (jobMiscCost) => {
    setOpenAddLineItem(true);
    setLineItemContent({
      Title: "Edit MiscCost",
      Type: "MiscCost",
    });
    setMiscCost({
      ...initialMiscCostState,
      ...jobMiscCost,
      costName: jobMiscCost.costName ?? "",
      budgetedCostAmount: jobMiscCost.budgetedCostAmount ?? 0,
      budgetedCustomerPrice: jobMiscCost.budgetedCustomerPrice ?? 0,
      actualCostAmount: jobMiscCost.actualCostAmount ?? 0,
      actualCustomerPrice: jobMiscCost.actualCustomerPrice ?? 0,
      billToCustomer: jobMiscCost.billToCustomer ?? false,
    });
  };
  

  const handleSaveJobMiscCost = async () => {
    if (validateMiscCostFields()) {
      setLoading(true);
      try {
        let budgetedFields = {
          budgetedCostAmount: 0,
          budgetedCustomerPrice: 0,
        };
        if (isActuals) {
          // Fetch current budgeted values for this misc cost
          const jobMiscs = await GetJobMiscCosts(workReq?.workReqID || 0, miscCost.miscCostID, miscCost.jobID, navigate);
          const current = Array.isArray(jobMiscs) ? jobMiscs.find(m => m.miscCostID === miscCost.miscCostID) : null;
          if (current) {
            budgetedFields = {
              budgetedCostAmount: current.budgetedCostAmount ?? 0,
              budgetedCustomerPrice: current.budgetedCustomerPrice ?? 0,
            };
          }
        } else {
          budgetedFields = {
            budgetedCostAmount: miscCost.budgetedCostAmount,
            budgetedCustomerPrice: miscCost.budgetedCustomerPrice,
          };
        }
        const payloadJobMiscCost = {
          miscCostID: miscCost.miscCostID,
          jobID: miscCost.jobID,
          costName: miscCost.costName,
          costDescription: miscCost.costDescription,
          billToCustomer: miscCost.billToCustomer,
          sortOrder: miscCost.sortOrder,
          ...budgetedFields,
          ...(isActuals ? {
            actualCostAmount: miscCost.actualCostAmount,
            actualCustomerPrice: miscCost.actualCustomerPrice,
          } : {}),
        };
        const result = await SaveJobMiscCost(payloadJobMiscCost, navigate, isActuals);
        if (result && !result.isError) {
          setOpenAddLineItem(false);
          toast.success(`Other Cost saved successfully.`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error saving MiscCost:', error);
      } finally {
        setLoading(false);
        fetchJobMiscCosts(workReq?.workReqID);
        ResetMiscCost();
      }
    }
  }

  const handleJobMiscCostDelete = async (jobMiscCostID) => {
    if (jobMiscCostID) {
      try {
        const result = await DeleteJobMiscCost(jobMiscCostID, jobID, navigate);
        if (result && !result.isError) {
          fetchJobMiscCosts(workReq?.workReqID);
          toast.success(`Other Cost removed successfully.`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting MiscCost:', error);
      }
    }
  }

  useEffect(() => {
    if (Object.keys(miscCostErrors).length > 0) {
      const timer = setTimeout(() => {
        setMiscCostErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [miscCostErrors]);
  //#endregion MiscCost

  const LineItemProps = {
    handleAddLineItemOpenAsset,
    handleAddLineItemOpenObservation,
    handleAddLineItemOpenLabor,
    handleAddLineItemOpenSubcontractor,
    handleAddLineItemOpenMaterial,
    handleAddLineItemOpenOtherCosts,
    openAddLineItem,
    handleLineItemClose,
    LineItemContent,
    assetTypesList,
    assetsList,
    asset,
    fetchTypeCatalog,
    fetchAssets,
    handleAssetChange,
    assetErrors,
    handleSave,
    jobAssetList,
    handleJobAssetDelete,
    handleJobAssetEdit,
    rowsAsset,
    fetchJobAssets,
     units,
    fetchUnitsData,
    handleUnitCreated,
  };

  const LineItemObservationProps = {
    observationErrors,
    jobObservationList ,  
    observation,
    handleObservationChange,    
    handleJobObservationEdit,
    handleJobObservationDelete,
    fetchJobObservations,  
  }

  const LineItemMaterialProps = {
    materialErrors,
    jobMaterialList ,  
    material,
    handleMaterialChange,    
    handleJobMaterialEdit,
    handleJobMaterialDelete,
    fetchJobMaterials, 
    materialsList,
    materialTypesList,
    rowsMaterial,
     units,
    fetchUnitsData,
    handleUnitCreated,
    fetchTypeCatalog,  // ← ADD THIS
    fetchMaterials,    // ← ADD THIS
  }

  const LineItemLaborProps = {
    laborErrors,
    jobLaborList ,  
    labor,
    handleLaborChange,    
    handleJobLaborEdit,
    handleJobLaborDelete,
    fetchJobLabors, 
    skillTypesList,
    employeeList,
    rowsLabor,
  } 

  const LineItemSubcontractorProps = {
    subcontractorErrors,
    jobSubcontractorList,
    subcontractor,
    handleSubcontractorChange,
    handleJobSubcontractorEdit,
    handleJobSubcontractorDelete,
    fetchJobSubcontractors,
    subcontractorList,
    rowsSubcontractor
  }

  const LineItemMiscCostProps = {
    miscCostErrors,
    jobMiscCostList ,  
    miscCost,
    handleMiscCostChange,    
    handleJobMiscCostEdit,
    handleJobMiscCostDelete,
    fetchJobMiscCosts,
    rowsMiscCost, 
  }

  return {
    LineItemProps,
    LineItemObservationProps,
    LineItemMaterialProps,
    LineItemLaborProps,
    LineItemSubcontractorProps,
    LineItemMiscCostProps,
  };
};
